<template>
  <div>
    <div class="marginCenter">
      <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb">
        <div class="left flex">
          <div class="line"></div>
          <span>院内申请</span>
        </div>
        <div class="right flex-yCenter">
          <img src="@/assets/images/index/fanhui.png" alt="" />
          <router-link
            tag="span"
            to="/report/index"
            class="backIndex fcolor_blue2 fsize16"
          >
            返回
          </router-link>
        </div>
      </div>
      <div class="wrap">
        <div class="title">
          <span class="fsize32">人事科报到</span>
          <div class="xian"></div>
        </div>
        <div class="wrap">
          <!-- <div class="status s1">已上传</div> -->
          <div class="status s2">未上传</div>
          <!-- <div class="status s3">无需上传</div> -->
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-change="handleChange"
            :file-list="fileList"
          >
            <el-button type="primary" class="upload">上传凭证</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
          <!-- <el-button type="primary" class="upload">上传凭证</el-button> -->
        </div>
      </div>
      <div class="description">
        <div class="text fsize16">上传说明：</div>
        <div class="info fsize16">
          <span>庆春院区</span><br />
          <span>1圣诞节安康了解到撒汇款单哈斯卡的撒客户端</span>
        </div>
      </div>
      <div class="btn"><el-button type="primary">确认提交</el-button></div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      fileList:[]
    };
  },
  methods: {
    handleChange() {}
  },
};
</script>
<style lang="scss" scoped>
.backIndex:hover {
  cursor: pointer;
}
.applyType {
  margin-top: 110px;
}
.remark {
  margin: 32px 0 110px 0;
}
.el-button--primary {
  width: 300px;
  height: 60px;
  background: #ffffff;
  color: #2d53c8;
  border-radius: 5px;
  border: 4px solid #2d53c8;
}
.wrap {
  margin-top: 68px;
  text-align: center;
  .title {
    text-align: center;
    &:first-child {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .xian {
      width: 74px;
      height: 6px;
      background: #2d53c8;
      border-radius: 5px;
      margin: 5px auto 0;
    }
  }
  .status {
    margin-bottom: 15px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1eb28f;
    line-height: 33px;
  }
  .s2 {
    color: #eb5b00;
  }
  .s3 {
    color: #999999;
  }
  .upload {
    width: 225px;
    height: 60px;
    background: #ffffff;
    border-radius: 5px;
    border: 4px solid #2d53c8;
  }
}
.description {
  margin-top: 58px;
  .text {
    font-size: 16px;
  }
  .info {
    line-height: 1.5;
    text-align: center;
  }
}
.btn {
  margin-top: 128px;
  text-align: center;
  button {
    background-color: #2d53c8;
    color: #fff;
    font-size: 22px;
    letter-spacing: 2px;
  }
}
</style>
